/**
 * Campo "Setor" do cadastro de ativos: escolha na lista de setores da operadora — Nexora Grid (frontend, US-1904).
 *
 * Criado em: 19/10/2026 · Última modificação: 19/10/2026 · Versão: 1.0.0
 *
 * A lista vem do cadastro estrutural (`/v1/admin/empresas/{empresa}/setores`, só os ativos). O ativo guarda o código em
 * maiúsculas (`RSE-001`, como vem da importação do DXF). Compatibilidade: valor antigo fora da lista continua aparecendo
 * e pode ser mantido; operadora ainda sem setores cadastrados usa o texto livre de antes.
 */
import { useEffect, useState } from "react";
import { api } from "../api";

type Setor = { codigo: string; nome: string; ativa: boolean };

export function CampoSetor({ empresa, id, valor, aoMudar, desabilitado = false }:
  { empresa: string | null; id: string; valor: string; aoMudar: (v: string) => void; desabilitado?: boolean }) {
  const [setores, setSetores] = useState<Setor[] | null>(null);
  useEffect(() => {
    if (!empresa) return;
    api<{ setores: Setor[] }>(`/v1/admin/empresas/${empresa}/setores`).then((r) => setSetores(r.setores.filter((s) => s.ativa)))
      .catch(() => setSetores([]));
  }, [empresa]);
  if (!setores || !setores.length) {
    return <input id={id} disabled={desabilitado} value={valor} onChange={(e) => aoMudar(e.target.value)} />;
  }
  const opcoes = [...new Map(setores.map((s) => [s.codigo.toUpperCase(), s.nome])).entries()];
  const fora = valor && !opcoes.some(([c]) => c === valor.toUpperCase());
  return (
    <select id={id} disabled={desabilitado} value={fora ? valor : valor.toUpperCase()} onChange={(e) => aoMudar(e.target.value)}>
      <option value="">—</option>
      {fora && <option value={valor}>{valor} (fora da lista)</option>}
      {opcoes.map(([c, nome]) => <option key={c} value={c}>{c} · {nome}</option>)}
    </select>
  );
}
